import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { useWizard } from 'ui-components/components/wizard/context';

import messages from '../../messages';
import style from '../style.module.less';

const BackButton = ({ disabled = false }) => {
  const { previousStep, stepBack, getStepLabel } = useWizard();

  const onClick = useCallback(() => {
    stepBack();
  }, [stepBack]);

  const isFirstStep = !previousStep;
  if (isFirstStep) {
    return null;
  }

  return (
    <Button className={classNames(style.button, style['back-link'])} disabled={disabled} onClick={onClick} theme='link'>
      <FontAwesomeIcon className={style.icon} icon={faArrowLeft} />
      <FormattedMessage
        {...messages.backButton}
        values={{
          previousStepLabel: getStepLabel(previousStep.stepId),
        }}
      />
    </Button>
  );
};

BackButton.propTypes = {
  disabled: PropTypes.bool,
};

export default BackButton;
